import { getClickGatewayUrl } from '@/config.js'

export const sendGatewayRequest = async (body, { gatewayUrl } = {}) => {
  const url = gatewayUrl || getClickGatewayUrl()

  if (!url) {
    throw new Error('Gateway URL is not configured')
  }

  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
    signal: AbortSignal.timeout(60_000),
  })

  const data = await response.json().catch(() => null)

  if (!response.ok) {
    throw new Error(data?.message || data?.text || data?.error || `Gateway HTTP ${response.status}`)
  }

  if (!data || typeof data !== 'object') {
    throw new Error('Gateway returned empty response')
  }

  return data
}
